export const MAIL_ROUTES = {
  __ROOT__: '/mail',
}
